import { render, staticRenderFns } from "./NewDetails.vue?vue&type=template&id=b51f62c6&scoped=true&slot-scope=scope&"
import script from "./NewDetails.vue?vue&type=script&lang=js&"
export * from "./NewDetails.vue?vue&type=script&lang=js&"
import style0 from "./NewDetails.vue?vue&type=style&index=0&id=b51f62c6&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b51f62c6",
  null
  
)

export default component.exports